var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.921 1.30001C1.936 0.532008 0.5 1.23401 0.5 2.48201V19.491C0.5 20.913 2.295 21.537 3.177 20.421L7.367 15.121C7.5216 14.9257 7.71842 14.7679 7.9427 14.6595C8.16698 14.5511 8.41289 14.4948 8.662 14.495H15.514C16.942 14.495 17.563 12.687 16.435 11.811L2.921 1.30001Z",
    fill: "#1ABB6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.5fb15a7a3503051f5e1f753066bd4973.svg";
export { ForwardRef as ReactComponent };